<template>
    <div class="my-2 " id="profile-blurb">
        <div class="max-w-xs mobile-lg:max-w-lg tablet-sm:max-w-screen-2xl mx-auto flex items-center justify-between">
            <div class="w-full p-2 flex ">
                <div
                    class="skew-x-[-30deg] px-4 tablet-sm:px-0 left-16 tablet-sm:left-1/4 absolute inset-y-0 z-0 -mr-96 w-[200%] origin-top-right bg-white shadow-xl shadow-light-lg/10 ring-1 ring-accent sm:-mr-80 lg:-mr-96"
                    aria-hidden="true"
                />
                <div
                    class="hidden tablet-sm:block w-60 tablet-lg:w-60 laptop-sm:w-64 laptop-lg:w-80 justify-center py-4 laptop-lg:py-0 z-10 ">
                    <img
                        id="gina-betbeze-portrait"
                        src="/images/theme/portrait.webp"
                        alt="Gina Betbeze Portrait"
                        class="w-40 h-auto tablet-lg:w-44 laptop-sm:w-48 laptop-lg:w-56 shadow-xl-left shadow-xl-top shadow-xl-bottom shadow-xl-top
                               relative border border-4 border-white"
                        loading="lazy"
                    />
                </div>
                <div class="px-1 tablet-lg:px-4 w-full pt-2 pb-4 z-10">
                    <div class="min-w-0 px-0 tablet-sm:px-4 flex justify-center">
                        <h1
                            class="text-center
                            ml-6 tablet-sm:ml-0 mr-0 mobile-lg:mr-2
                            pr-0 mobile-lg:pr-2
                            text-xl tablet-sm:text-2xl tablet-lg:text-4xl
                            font-display font-semibold
                            font-subtitle
                            tracking-tight
                            text-primary-text pt-0 mt-0 mb-0"
                        >
                            Gina Betbeze,<br class="tablet-sm:hidden"> Your Local Real Estate Expert
                        </h1>
                    </div>

                    <!-- segmented titles and details -->
                    <div
                        class="hidden laptop-sm:grid mx-0 px-0 mobile-lg:px-2  grid-cols-[auto_1fr] gap-x-2 px-2 mt-2">
                        <div class="flex items-start">
                            <CheckCircleIcon class="mt-1 w-4 h-4 text-accent mr-2 flex-shrink-0" />
                            <span class="font-semibold flex-shrink-0">Experience</span>
                            <span class="mx-1 flex-shrink-0">:</span>
                        </div>
                        <div class="items-start">
                            <span>20+ Years, New Construction, Relocation</span>
                        </div>
                        <div class="flex items-start">
                            <CheckCircleIcon class="mt-1 w-4 h-4 text-accent mr-2 flex-shrink-0" />
                            <span class="font-semibold flex-shrink-0">Location</span>
                            <span class="mx-1 flex-shrink-0">:</span>
                        </div>
                        <div class="items-start">
                            <span>Duval, St. Johns, and Clay County</span>
                        </div>
                    </div>

                    <div class="min-w-0 text-base leading-7 text-primary-text w-full mt-2">
                        <p class="text-base pt-2 px-2 leading-5">
                            <strong>I have been a licensed Realtor since 2002 and live on the border of NW St Johns
                                    and Duval
                                    County.</strong> I have extensive training and experience in handling relocation
                                                     sales for my
                            clients as well as my own family. Previously I lived in South Florida and Massachusetts.
                            <strong>I love helping families relocate to some of Northeast Florida’s most desirable
                            communities such as Julington Creek, Nocatee, and Rivertown.</strong> Based near the
                                Duval–St.
                            Johns County line, I focus on new construction, resales, relocation, and lifestyle-driven
                            neighborhoods . With over 20 years of experience in Northeast Florida real estate, I
                            bring unmatched local knowledge and trusted relocation expertise to help you transition
                            with confidence. <strong>Ready to explore?</strong><br><br>
                            Start with my <Link :href="'/#property-search'" preserve-state
                            >Property Search Tool to explore current listings</Link>, then use
                            the <Link :href="'/mortgage-calculator'" preserve-state
                            >mortgage calculator to see what fits your budget and timeline.
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { CheckCircleIcon } from '@heroicons/vue/24/solid'; // or '@heroicons/vue/24/outline' for outline version
import { Link } from "@inertiajs/vue3";
</script>
